import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../components/Layout/MainLayout';
import applicationService from '../services/applicationService';
import ApplicationCard from '../components/ApplicationCard';

const MyApplicationsPage = () => {
  const navigate = useNavigate();
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchApplications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchApplications = async () => {
    try {
      setLoading(true);
      const response = await applicationService.getApplications();
      
      if (response.success) {
        setApplications(response.applications);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to load applications');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <MainLayout>
        <div className="min-h-screen bg-background py-10 px-5 max-w-[1200px] mx-auto">
          <div className="flex flex-col items-center justify-center min-h-[400px] gap-4">
            <div className="w-12 h-12 border-4 border-[#E0E0E0] border-t-accent-green rounded-full animate-spin"></div>
            <p className="text-text-secondary text-[15px]">Loading applications...</p>
          </div>
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="min-h-screen bg-background py-10 px-5 max-w-[1200px] mx-auto">
        <div className="flex justify-between items-start mb-8 gap-5">
          <div>
            <h1 className="m-0 mb-1 text-[32px] font-bold text-primary">My Applications</h1>
            <p className="m-0 text-text-secondary text-[15px]">Track your application progress</p>
          </div>
          <button
            className="!px-4 !py-2 !bg-accent-green !text-white !border-none !rounded-lg !font-semibold !text-base cursor-pointer transition-all duration-200 whitespace-nowrap !w-auto !max-w-fit hover:bg-[#4d5f6b] hover:-translate-y-px hover:shadow-[0_4px_12px_rgba(107,127,92,0.3)]"
            onClick={() => navigate('/candidate/applications/new')}
          >
            New Application
          </button>
        </div>

        {error && (
          <div className="px-4 py-3 rounded-lg text-sm mb-5 bg-[#FFEBEE] text-[#C62828] border border-[#EF9A9A]">
            {error}
          </div>
        )}

        {applications.length === 0 ? (
          <div className="flex flex-col items-center justify-center min-h-[400px] text-center py-10 px-5">
            <div className="text-6xl mb-4 opacity-50">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
              </svg>
            </div>
            <h2 className="m-0 mb-2 text-2xl font-semibold text-primary">No Applications Yet</h2>
            <p className="m-0 mb-6 text-text-secondary text-[15px]">Start your journey by creating your first application</p>
            <button
              className="!px-4 !py-2 !bg-accent-green !text-white !border-none !rounded-lg !font-semibold !text-base cursor-pointer transition-all duration-200 whitespace-nowrap !w-auto !max-w-fit hover:bg-[#4d5f6b] hover:-translate-y-px hover:shadow-[0_4px_12px_rgba(107,127,92,0.3)]"
              onClick={() => navigate('/candidate/applications/new')}
            >
              Create Application
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-[repeat(auto-fill,minmax(350px,1fr))] gap-5">
            {applications.map((application) => (
              <ApplicationCard
                key={application._id}
                application={application}
                showCandidate={false}
              />
            ))}
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default MyApplicationsPage;
